define([], function placementModelServiceModule() {
  'use strict';

  var placementModelService = function placementModelService(riqApiService) {
    riqApiService.setApiEndpoints({
      getAsmtHistory: 'comp_check_get_reading_level_assessment_history',
      setActiveAssessedLevel: 'comp_check_set_active_assessed_reading_level',
      getAsmtSupportedInfo:
        'comp_check_get_reading_level_assessment_supported_info',
      getUserAsmtHistory: 'comp_check_get_user_assessment_history'
    });

    var getPlacementHistory = function getPlacementHistory(profileUuid) {
      return riqApiService.get(
        'getAsmtHistory',
        {
          profileUuid: profileUuid,
          stringify: false
        },
        false
      );
    };

    var getUserAssessHistory = function getUserAssessHistory(profileUuids) {
      return riqApiService.get(
        'getUserAsmtHistory',
        {
          profileUuids: profileUuids,
          stringify: false
        },
        false
      );
    };

    var setActiveAsmtLevel = function setActiveAsmtLevel(data) {
      return riqApiService.get(
        'setActiveAssessedLevel',
        {
          profileUuid: data.profileUuid,
          gradeLevel: data.gradeLevel,
          stringify: false
        },
        false
      );
    };

    var getAsmtSupportedInfo = function getAsmtSupportedInfo() {
      return riqApiService.get('getAsmtSupportedInfo');
    };

    return {
      getPlacementHistory: getPlacementHistory,
      setActiveAsmtLevel: setActiveAsmtLevel,
      getAsmtSupportedInfo: getAsmtSupportedInfo,
      getUserAssessHistory: getUserAssessHistory
    };
  };

  return placementModelService;
});
